export default "__VITE_ASSET__B8b1q6r8__"